import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  profileUserData: {
    directorate:"",
    division:"",
    department:"",
    group:"",
    role:"",
    institution:"",
    sub_unit:"",
    unit:""
  }
}

export const leaderboardsSlice = createSlice({
  name: 'leaderboard',
  initialState,
  reducers: {
    setProfileUserData: (state, action) => {
      state.profileUserData = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setProfileUserData } = leaderboardsSlice.actions

export default leaderboardsSlice.reducer